let _scrollbarWidth: number;

function calcScrollbarWidth() {
    const scrollDiv = document.createElement('div');

    scrollDiv.style.position = 'absolute';
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.style.height = '50px';
    scrollDiv.style.width = '50px';
    scrollDiv.style.top = '-9999px';

    document.body.appendChild(scrollDiv);
    const result = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);

    return result;
}

export default function () {
    if (_scrollbarWidth !== undefined) {
        return _scrollbarWidth;
    }

    const scrollbarWidth = calcScrollbarWidth();
    _scrollbarWidth = scrollbarWidth;

    return scrollbarWidth;
}
